/* globals ga */

import { isLocal } from './environment';

export const pushEvent = (category, action) => {
    if (window.ga && !isLocal())
    {
        ga('send', 'event', {
            hitType: 'event',
            eventCategory: 'Platform',
            eventAction: `${category}_${action}`,
            eventLabel: ''
        });
    }
};

export const pushPageView = (url) => {
    if (window.ga && !isLocal())
    {
        ga('send', {
            hitType: 'pageview',
            page: location.pathname,
            location: url,
            title: document.title
        });
    }
};



// WEBPACK FOOTER //
// ./app/src/js/utils/tracking.js